import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import dayjsImport from "./auth-service-tools36.js";
import { shiftTimezone } from "./auth-service-tools574.js";
import { useDatesContext } from "./auth-service-tools577.js";
import classes from "./auth-service-tools580.js";
import { factory } from "./auth-service-tools248.js";
import { useProps } from "./auth-service-tools225.js";
import { useStyles } from "./auth-service-tools198.js";
import { UnstyledButton } from "./auth-service-tools258.js";
import { createVarsResolver } from "./auth-service-tools191.js";
import { getSize } from "./auth-service-tools185.js";
const defaultProps = {};
const varsResolver = createVarsResolver((_, _ref) => {
  let {
    size
  } = _ref;
  return {
    day: {
      "--day-size": getSize(size, "day-size")
    }
  };
});
const Day = factory((_props, ref) => {
  const props = useProps("Day", defaultProps, _props);
  const {
    classNames,
    className,
    style,
    styles,
    unstyled,
    vars,
    date,
    disabled,
    __staticSelector,
    weekend,
    outside,
    selected,
    renderDay,
    inRange,
    firstInRange,
    lastInRange,
    hidden,
    static: isStatic,
    highlightToday,
    ...others
  } = props;
  const getStyles = useStyles({
    name: __staticSelector || "Day",
    classes,
    props,
    className,
    style,
    classNames,
    styles,
    unstyled,
    vars,
    varsResolver,
    rootSelector: "day"
  });
  const ctx = useDatesContext();
  return /* @__PURE__ */jsxRuntimeExports.jsx(UnstyledButton, { ...getStyles("day", {
      style: hidden ? {
        display: "none"
      } : void 0
    }),
    component: isStatic ? "div" : "button",
    ref,
    disabled,
    "data-today": dayjsImport(date).isSame(shiftTimezone("add", /* @__PURE__ */new Date(), ctx.getTimezone()), "day") || void 0,
    "data-hidden": hidden || void 0,
    "data-highlight-today": highlightToday || void 0,
    "data-disabled": disabled || void 0,
    "data-weekend": !disabled && !outside && weekend || void 0,
    "data-outside": !disabled && outside || void 0,
    "data-selected": !disabled && selected || void 0,
    "data-in-range": inRange && !disabled || void 0,
    "data-first-in-range": firstInRange && !disabled || void 0,
    "data-last-in-range": lastInRange && !disabled || void 0,
    "data-static": isStatic || void 0,
    unstyled,
    ...others,
    children: (renderDay == null ? void 0 : renderDay(date)) || date.getDate()
  });
});
Day.classes = classes;
Day.displayName = "@mantine/dates/Day";
export { Day };